<template>
    <div>
        <div v-if="canAssignUsersToProject(project)" @click="onClick('assign')" id="btn-project-members"
             name="btn-project-members">
            <i class="material-icons">person_add</i>
        </div>

        <div v-else @click="onClick('members')" id="btn-project-members" name="btn-project-members">
            <i class="material-icons">person</i>
        </div>

        <tippy showOnInit="false" theme="" to="btn-project-members">
            {{ canAssignUsersToProject(project) ? "Manage Users and Guests" : "Project Members" }}
        </tippy>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],
    computed: {
        ...mapState("Projects", ["project"]),
        ...mapState("UI", ["startTips"]),
    },
    methods: {
        onClick(modal) {
            // if (vm.$store.state.UI.startTips == 5) {
            //     vm.$store.dispatch("UI/setStartTips", "completed");
            // }

            this.$store.dispatch("Projects/selectProjectSettings", this.$store.state.Projects.project.id);

            if (modal == "assign") {
                this.$store.dispatch("Organizations/fetchUsers");
                window.UI.showModal(window.$("#modal-assign-users"));
            } else {
                window.UI.showModal(window.$("#modal-project-members"));
            }
        },
    },
};
</script>

<style lang="scss">

#btn-project-members {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    border: 1px solid transparent;
    background: #363636;
    width: 30px;
    height: 30px;
    margin-right: 20px;

    i {
        cursor: pointer;
        font-size: 18px;
    }
}
</style>
